import { styled } from '@linaria/react';

export const RegulationsIntro = styled.div`
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
`;

export const RegulationsTable = styled.div`
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;

    .table-header,
    .table-row {
        display: grid;
        grid-template-columns: 150px 1fr;
        padding: 0.75rem;
        border-bottom: 1px solid #dee2e6;
        font-size: 0.875rem;
    }

    &.editable {
        .table-header,
        .table-row {
            grid-template-columns: 40px 150px 1fr;
        }
    }

    .table-header {
        background: rgb(238 238 238);
        font-weight: 700;
        color: #495057;
    }

    .table-row {
        color: #333;
        transition: background 0.2s;

        &:hover {
            background: #f8f9fa;
        }
    }

    .table-footer {
        display: grid;
        grid-template-columns: 40px 1fr;
        padding: 0.75rem;
        background: #f8f9fa;
        border-top: 1px solid #dee2e6;

        select {
            width: 400px;
            padding: 0.5rem;
            border: 1px solid #ccc;
            border-radius: 4px;
            font-size: 0.875rem;
        }
    }
`;

export const DeleteButton = styled.button`
    background: transparent;
    border: none;
    color: #dc3545;
    cursor: pointer;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s, color 0.2s;

    &:hover {
        background: #dc3545;
        color: white;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;
